import React from 'react';

export const ApiContext = React.createContext({
  Api: null,
});
ApiContext.displayName = 'ApiContext';
